import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION7: PdfComponent = {
  type: 'section',
  id: 's1s7',
  title: '7. Fair Processing Notices and User Terms',
  content: [
    {
      type: 'bulletList',
      id: 's1s7bullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: '7fairp',
            content: [
              'The parties shall ensure that a ',
              'Fair Processing Notice',
              ', substantially in the form agreed between them, is made available to each Data Subject whose Personal Information is collected or processed in connection with this Agreement.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: 'The Fair Processing Notice shall comply with the requirements of Data Privacy Laws and shall include:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'the identity and contact details of each Joint Controller;',
              },
              {
                copy: 'the purposes for which Personal Information will be collected and processed;',
              },
              {
                copy: 'the legal basis for such processing;',
              },
              {
                copy: 'the rights of the Data Subject, including the right to object, access, rectify, erase or restrict processing of Personal Information;',
              },
              {
                copy: 'the contact details of the Key Data Protection Representatives;',
              },
              {
                copy: 'the potential recipients of the Personal Information;',
              },
              {
                copy: 'whether the data will be transferred outside the UK or EEA and, if so, details of appropriate safeguards; and',
              },
              {
                copy: 'any other information required to comply with Article 13 or 14 of the UK GDPR.',
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 's1s7userterms',
            content: [
              'The parties shall also ensure that appropriate ',
              'User Terms',
              ' (including those relating to privacy and data use) are implemented and kept up to date on any system or platform where Data Subjects input or access Personal Information, in compliance with applicable laws and the terms of this Agreement.',
            ],
            boldFirst: false,
          },
        },
      ],
      prefix: '7',
    },
  ],
};
